module.exports = __webpack_public_path__ + "img/Phone_White@2x.20472f7e.png";